import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { NotificationService } from "./notification.service";

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const notificationService: NotificationService = this.injector.get(
      NotificationService
    );
    return next.handle(req).pipe(
      tap((evt: HttpEvent<any>): any => {
        if (req.headers.get("skip")) {
          return next.handle(req);
        }
        if (evt instanceof HttpResponse) {
          // Check if body exists and has success property
          if (evt.body && evt.body.success) {
            // Only show notification if success is an object with a message
            // This prevents crashing when success is just 'true' (boolean)
            if (typeof evt.body.success === 'object' && evt.body.success.message) {
              notificationService.success(evt.body.success.message);
            }
          }
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          // Check if this is a dependency error - preserve it without showing notifications
          if (err.status === 400 && err.error && err.error.hasDependencies) {
            return throwError(() => err); // Preserve the original HttpErrorResponse
          }
          
          try {
            switch (err.status) {
              case 404:
                notificationService.error(
                  "Record Not Found. Please try again or contact support."
                );
                break;
              case 500:
                notificationService.error(err.error.ErrorMessage);
                break;
              case 403:
                notificationService.error(
                  "Your User Level is not Authorized to do this"
                );
                break;
              default:
                if (err.error && typeof err.error === "string") {
                  notificationService.error(err.error);
                } else if (
                  err.error &&
                  err.error.message &&
                  typeof err.error.message === "string"
                ) {
                  notificationService.error(err.error.message);
                } else if (
                  err.error &&
                  Array.isArray(err.error.errors) &&
                  err.error.errors.length
                ) {
                  // A flat list of messages or i18n keys — the shape
                  // CustomErrorHandlerService already documents as preserved. It has to be
                  // handled before the ModelState branch below: Object.keys() on an array
                  // yields "0", so that branch indexes into the STRING and toasts its first
                  // character. A rejected password change showed a toast reading "U".
                  notificationService.error(err.error.errors[0]);
                } else if (
                  err.error &&
                  err.error.errors &&
                  Object.keys(err.error.errors) &&
                  Object.keys(err.error.errors).length
                ) {
                  // specific validation errors
                  const err2 =
                    err.error.errors[Object.keys(err.error.errors)[0]];
                  if (err2 && err2.length > 1) {
                    notificationService.error(err2[0]);
                  } else if (err2) {
                    notificationService.error(err2[0]);
                  }
                } else {
                  notificationService.error(err.statusText);
                }
                break;
            }
          } catch (e) {
            notificationService.error(
              "Something went wrong while making your request. Please try again."
            );
          }
          //log error
        }
        return throwError(() => err); // Changed this line to preserve original error structure
      })
    );
  }
}
